const addThousandSeparators = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export { addThousandSeparators };

/* Export default para pasar la regla de linter, cuando se agreguen mas métoodos se debe eliminar */
export default addThousandSeparators;
